<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>PART II</span></p>
<p class="chap-title-2"><span>THE SECOND<br/>MASSACHUSETTS</span></p>
<p class="center"><span>T<span class="smallcaps">HE</span> S<span class="smallcaps">ECOND</span> M<span class="smallcaps">ASSACHUSETTS</span> V<span class="smallcaps">OLUNTEER</span> I<span class="smallcaps">NFANTRY</span></span></p>
<p class="normal"><i>The sons of the first gentlemen of New England generously vied with each other in seeking commissions therein.… From the first it was often spoken of as the model regiment in the army for its admirable drill; and so tenaciously has it preserved its early distinction, that in its last battle, when half its number of privates and eleven of its officers had fallen, it manoeuvred still under the severest fire with “every man in his place;”—a proud deed</i>!</p>
<p class="right"><span><i>—B<span class="smallcaps">OSTON</span> H<span class="smallcaps">ERALD,</span></i> J<span class="smallcaps">ULY 1863</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part2chapter01.vue?55338222